// Utility to log and retrieve audit history in client storage
const AUDIT_STORAGE_PREFIX = "audit_trail_history_";

export function getStoredAuditHistory(entityType, recordId) {
  if (!recordId) return [];
  try {
    const key = `${AUDIT_STORAGE_PREFIX}${entityType}_${recordId}`;
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function logAuditChange({ entityType, recordId, diff, userId, actionType = "modified", timestamp = null }) {
  if (!recordId || !diff || diff.length === 0) return;
  try {
    const key = `${AUDIT_STORAGE_PREFIX}${entityType}_${recordId}`;
    const history = getStoredAuditHistory(entityType, recordId);
    const newEntry = {
      type: actionType,
      date: timestamp || new Date().toISOString(),
      userId: userId,
      diff: diff,
    };
    const updated = [newEntry, ...history].slice(0, 20);
    localStorage.setItem(key, JSON.stringify(updated));
  } catch (err) {
    console.warn("Failed to log audit change:", err);
  }
}

export function computeFieldDiff(oldObj = {}, newObj = {}, skipFields = new Set()) {
  const diff = [];
  const allKeys = new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})]);

  for (const key of allKeys) {
    if (skipFields.has(key)) continue;
    const oldVal = oldObj[key];
    const newVal = newObj[key];

    // Normalize for comparison
    const oldStr = oldVal == null ? "" : String(oldVal).trim();
    const newStr = newVal == null ? "" : String(newVal).trim();

    if (oldStr !== newStr) {
      diff.push({
        field: key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (c) => c.toUpperCase())
          .trim(),
        before: oldVal == null || oldVal === "" ? "—" : String(oldVal),
        after: newVal == null || newVal === "" ? "—" : String(newVal),
      });
    }
  }
  return diff;
}
